module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Copyright",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_vm._v("Copyright © 2004, 2022 by D"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("avid Kundtz.")]), _c('br'), _vm._v("Published by Conari Press, a division of Mango Publishing"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" Group, Inc.")])]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("Cover Design: "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("Megan Werner")]), _c('br'), _vm._v("Layout & Design: Carm"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("en Fortunato")])]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("Some of the material in this book was self-published in 1990 and published by Health Communications, Inc. under the title "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("Men and Feelings: Understanding the Male Experie")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("nce in 1991.")])])]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("In all the case histories and examples of this book, names and other nonessential facts have been deliberately scrambled and changed in order to protect the rights of confidentiality "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("and privacy.")])]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("Mango is an active supporter of authors’ rights to free speech and artistic expression in their books. The purpose of copyright is to encourage authors to produce exceptional works that enrich our culture and our o"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("pen society.")])]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("Uploading or distributing photos, scans or any content from this book without prior permission is theft of the author’s intellectual property. Please honor the author’s work as you would your own. Thank you in advance for respecting our auth"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("or’s rights.")])]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("For permission requests, please contact the p"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ublisher at:")]), _c('br'), _vm._v("Mango Publ"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ishing Group")]), _c('br'), _vm._v("2850 S Douglas Roa"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("d, 4th Floor")]), _c('br'), _vm._v("Coral Gables, "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("FL 33134 USA")]), _c('br'), _c('a', {
    attrs: {
      "href": "mailto:info@mango.bz"
    }
  }, [_vm._v("i"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("nfo@mango.bz")])])]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("For special orders, quantity sales, course adoptions and corporate sales, please email the publisher at "), _c('a', {
    attrs: {
      "href": "mailto:sales@mango.bz"
    }
  }, [_vm._v("sales@mango.bz")]), _vm._v(". For trade and wholesale sales, please contact Ingram Publisher Services at "), _c('a', {
    attrs: {
      "href": "mailto:customer.service@ingramcontent.com"
    }
  }, [_vm._v("customer.service@ingramcontent.com")]), _vm._v(" or +1.8"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("00.509.4887.")])]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("Nothing’s Wrong: A Man’s Guide to Manag"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ing Emotions")])]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("Library of Congress Cataloging-in-Publication number"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(": 2022937648")]), _c('br'), _vm._v("ISBN: (print) 978-1-68481-028-4, (ebook) 978-1"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("-68481-029-1")]), _c('br'), _vm._v("BISAC: SOC018000, SOCIAL SCIENCE / M"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("en’s Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "Copyright _idGenParaOverride-1"
  }, [_vm._v("Printed in the United State"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("s of America")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7723b6c5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NothingsWrong-2.vue
// module id = 66
// module chunks = 0